"use client";

import { Dispatch, FC, SetStateAction } from "react";
import { signIn, useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useDispatch } from "react-redux";
import { Button } from "@ui/atom/Button";

interface KeycloakLoginButtonProps {
  className?: string;
  setIsModalOpen?: (isOpen: boolean) => void;
  loadingState: [boolean, Dispatch<SetStateAction<boolean>>];
}

const KeycloakLoginButton: FC<KeycloakLoginButtonProps> = ({
  className = "",
  setIsModalOpen,
  loadingState,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { data: session } = useSession();
  const [loading, setLoading] = loadingState;

  const handleKeycloakLogin = async () => {
    setLoading(true);
    try {
      const result = await signIn("keycloak", {
        redirect: false,
        callbackUrl: "/login", // We'll create this route for handling auth
      });

      if (result?.error) {
        setLoading(false);
        console.error("Keycloak login failed:", result.error);
        return;
      }
    } catch (error) {
      setLoading(false);
      console.error("Login error:", error);
    }
  };

  return (
    <Button
      type="primary"
      onClick={handleKeycloakLogin}
      className={"h-14 mb-6 bg-blue-600 " + className}
      loading={loading}
    >
      Login with Keycloak
    </Button>
  );
};

export default KeycloakLoginButton;
